import { render, staticRenderFns } from "./OAuthCallbackForSSO.vue?vue&type=template&id=551fe690"
import script from "./OAuthCallbackForSSO.vue?vue&type=script&lang=js"
export * from "./OAuthCallbackForSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports